import React, { useContext, useMemo } from 'react'
import { IAlertBio } from '@/api/notification/getNotificationBio.ts'
import { format } from 'date-fns'
import GreenIcon from '@/assets/img__bio_alert__green.svg?react'
import RedIcon from '@/assets/img__bio_alert__red.svg?react'
import { BioAlertModalContext } from '@/pages/notification/bio/BioAlertModal.tsx'
import { useTranslation } from 'react-i18next'
import useQueryGetMe from '@/api/auth/getMe.ts'

export interface IProps extends IAlertBio {
    className?: string
}

const BioAlertItem: React.FC<IProps> = ({ className, protectee, alert, id }) => {
    const { t } = useTranslation()
    const { data: me } = useQueryGetMe()
    
    // 특정 이메일 계정인지 확인
    const isMaskingRequired = useMemo(() => {
        return me?.email === 'dbd_cm@clomental.com'
    }, [me?.email])
    
    // 마스킹 처리 함수
    const getMaskedName = (name?: string) => {
        if (!isMaskingRequired || !name) return name
        if (name.length <= 1) return name
        return name.charAt(0) + '**'
    }

    const renderStatusIcon = useMemo(() => {
        if (alert?.taskManagerAt) {
            return <GreenIcon />
        } else {
            return <RedIcon />
        }
    }, [alert?.taskManagerAt])

    const { id: selectedId, setId } = useContext(BioAlertModalContext)

    const isSelected = useMemo(() => {
        return id == selectedId
    }, [id, selectedId])

    return <div
        className={`${className} rounded-[10px] flex justify-between items-center px-[20px] min-h-[40px] ${isSelected ? 'bg-main_b text-white' : 'bg-sub_b'} border ${!!alert?.isMyTask && selectedId != id ? 'border-sub_r' : 'border-transparent'} border-solid hover:border-main_b active:bg-main_b active:text-white cursor-pointer text-[14px]`}
        onClick={() => setId(id)}>
        {renderStatusIcon}
        <p>{getMaskedName(protectee?.name)}</p>
        <p>{format(alert?.createdAt, 'HH:mm:ss')}</p>
        <p>{alert?.taskManagerAt ? t('notification.bioModal.list.item.allotment') : t('notification.bioModal.list.item.new')}</p>
    </div>
}

export default BioAlertItem